<template>
  <main class="donate" id="donate">
    <section>
      <h1>Поддержка проекта</h1>

      <client-only>
        <Premium />
      </client-only>

      <div class="header">
        <i class="sitecoin-header" />

        <div class="bill-form">
          <div style="margin:0px 0px 30px;">
            <p style="color:red;font-size:1.8rem;">
              Не забудьте указать свой ID в сообщение к донату!
            </p>
            <p v-if="user" style="font-weight:600;">
              {{ user.id }}
            </p>
          </div>

          <label for="bill-amount">
            <strong style="display:block;font-size:3rem;font-weight:800;">Сумма перевода</strong>
            <div>
              <div style="position:relative;display:inline-block;">
                <input id="bill-amount" type="number" v-model="billAmount" placeholder="Сумма пожертвования" />
                <span :style="`position:absolute;right:20px;top:24px;font-size:2rem;opacity:0.35;`">руб.</span>
              </div>
              <button @click="createBill" class="dbtn green">&#9989; Отправить</button>
              <strong v-if="user">Баланс: </strong>{{ user.balance.toFixed(2) }} Монет
            </div>
          </label>

          <div style="margin:0px 0 40px;">
            <strong style="font-size:1.6rem;">Вернется на баланс</strong>
            <div style="display:inline-block;margin-top:10px;">
              <div class="sitecoin">
                <i />
                <span><b style="color:red;">+</b>{{ billAmount }} Монет</span>
              </div>
            </div>
            <p style="font-size:1.2rem;">1 руб = 1 Монета</p>
          </div>

          <div style="margin:30px 0px 10px;">
            <a href="https://donate.stream/r0n1x" rel="nofollow noreferrer noopener">
              <img
                src="data:image/png;base64,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"
                alt=""
                style="width: 100px; height: 100px;"
              >
            </a>
          </div>

          <div style="margin:0px 0px 10px;">
            <p>
              Если Монеты не поступили на баланс после оплаты в течение 10 минут, обратитесь к Администрации.
            </p>
            <ul>
              <li>ВКонтакте <a href="https://vk.com/r0n1x" target="_blank">https://vk.com/r0n1x</a></li>
              <li>Телеграм <a href="https://t.me/r0n1x" target="_blank">https://t.me/r0n1x</a></li>
            </ul>
          </div>
        </div>
      </div>
          
      <div class="bhint patron">
        <strong>За поддержку на общую сумму (единоразово или за несколько переводов) свыше 5 000 руб. Вы получите статус
          <b>Patron</b> - особые привилегии на сайте и вечный Premium+.</strong>
      </div>
    </section>

    <section class="donaters">
      <h2><i class="crown" />Великолепная 20-ка</h2>

      <div v-if="donaters.length" class="list">
        <div v-for="(user, i) in donaters" :key="`donater-${i}-${user.name}`" class="item">
          <div class="pos">
            {{ i + 1 }}
          </div>
          <div class="poster">
            <img :src="user.photo" :alt="user.name">
          </div>
          <strong>
            <i
              v-if="user.group === 777 || user.group === 0"
              :class="{ 'patron': user.patron || user.group === 0 }"
              class="crown"
            />
            <i v-else />
            {{ user.name }}
          </strong>
          <span>{{ user.amount }}</span>
        </div>
      </div>
      <p v-else>
        Будь первым кто поддержит сайт! <a href="#donate">Поддержать</a>
      </p>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    Premium: () => import('~/components/Premium.vue'),
  },
  head() {
    return {
      title: `Поддержка сайта`,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: 'https://animeitochka.ru/dobto'
        }
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Поддержки проект и получи Premium - преимущества.`
        }
      ]
    }
  },
  filters: {
    filterBillDate(val) {
      const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ]
      const year = new Date(val).getFullYear()
      const month = new Date(val).getMonth()
      const day = new Date(val).getDate() < 10
        ? `0${new Date(val).getDate()}`
        : new Date(val).getDate()
      const hour = new Date(val).getHours() < 10
        ? `0${new Date(val).getHours()}`
        : new Date(val).getHours()
      const minute = new Date(val).getMinutes() < 10
        ? `0${new Date(val).getMinutes()}`
        : new Date(val).getMinutes()
      const seconds = new Date(val).getSeconds() < 10
        ? `0${new Date(val).getSeconds()}`
        : new Date(val).getSeconds()
      return `${day} ${months[month]} ${year} ${hour}:${minute}:${seconds}`
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async asyncData({ $axios, error }) {
    const { data } = await $axios.get(`/api/donaters`)
    if (data.error) error(error)
    return {
      donaters: data,
      billAmount: 50,
    }
  },
  data() {
    return {
    }
  },
  methods: {
    createBill() {
      // this.$store.commit('setError', { status: 'info', msg: 'Временно не доступно' })
      // setTimeout(() => this.$store.commit('clearError'), 2000)

      if (!this.user) {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }

      const result = confirm('Помните что нужно указать свой ID?')
      if (!result) return
      location.href = 'https://donate.stream/r0n1x' // "https://pay.cloudtips.ru/p/8230d670"
    },
  }
}
</script>

<style src="~/assets/donate.styl" lang="stylus" />
